import {Buffer} from 'buffer';
import { useState, useEffect } from 'react'
const crypto = window.crypto;

export const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

export const maskEmailAddress = (emailAddress) => {
  function mask(str) {
    var strLen = str.length;
    if (strLen > 4) {
      return str.substr(0, 1) + str.substr(1, strLen - 1).replace(/\w/g, '*') + str.substr(-1, 1);
    }
    return str.replace(/\w/g, '*');
  }
  return emailAddress.replace(/([\w.]+)@([\w.]+)(\.[\w.]+)/g, function (m, p1, p2, p3) {
    return mask(p1) + '@' + p2 + p3;
  });
};

export const maskCellNumber = (cellNumber) => {
  const length = cellNumber.length;
  return Array.from(cellNumber)
    .map((value, index) => {
      if (index === 0 || index === 1) {
        return value;
      } else if (index === length - 1 || index === length - 2 || index === length - 3) {
        return value;
      } else {
        return '*';
      }
    })
    .join()
    .replace(/,/g, '');
};

export const roundTo = (value, numberDecimals = 2) => {
  return value ? parseFloat(value + Number.EPSILON).toFixed(numberDecimals) : null;
};

export const toB64 = (obj) => Buffer.from(JSON.stringify(obj),'ascii').toString('base64');

export const fromB64 = (b64) => JSON.parse(Buffer.from(b64, 'base64').toString('ascii'));

export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return debouncedValue;
};

// maxx 8 digits
export const getRandomValues = (length) => {
  let numero = (crypto.getRandomValues(new Uint32Array(1))[0]).toString();
  while (numero.length < length) {
    numero = `${numero}${(crypto.getRandomValues(new Uint32Array(1))[0]).toString()}`;
  }

  return parseInt(numero.substr(0, length));


}
